import React from 'react';
import { useDebounce } from 'react-use';
import Textbox from '../Inputs/Textbox/Textbox';
import S from './HTAMemberSearch.styles';
const HTAMemberSearch = ({ content, locationValue: initialLocationValue = '', nameValue: initialNameValue = '', title, onLocationChange, onNameChange, }) => {
    const [mode, setMode] = React.useState('name');
    const [rawNameValue, setRawNameValue] = React.useState(initialNameValue);
    const [rawLocationValue, setRawLocationValue] = React.useState(initialLocationValue);
    // Debounce typing to ensure we don't spam the API.
    useDebounce(() => {
        onNameChange(rawNameValue);
    }, 300, [rawNameValue]);
    useDebounce(() => {
        onLocationChange(rawLocationValue);
    }, 300, [rawLocationValue]);
    return (React.createElement(S.Container, { flush: "both" },
        React.createElement(S.Inner, null,
            React.createElement(S.ContentWrapper, null,
                React.createElement(S.Title, null, title),
                React.createElement(S.Content, null,
                    React.createElement("p", null, content)),
                React.createElement(S.ModeList, null,
                    React.createElement(S.ModeItem, { htmlFor: "name" },
                        React.createElement(S.ModeInput, { id: "name", type: "radio", name: "mode", value: "name", checked: mode === 'name', onChange: () => {
                                setMode('name');
                                onLocationChange('');
                            } }),
                        React.createElement(S.ModeText, null, "Business Name")),
                    React.createElement(S.ModeItem, { htmlFor: "location" },
                        React.createElement(S.ModeInput, { id: "location", type: "radio", name: "mode", value: "location", checked: mode === 'location', onChange: () => {
                                setMode('location');
                                setRawNameValue('');
                            } }),
                        React.createElement(S.ModeText, null, "Location"))),
                mode === 'name' && (React.createElement(S.FieldWrapper, null,
                    React.createElement(S.FieldLabel, { htmlFor: "nameValue" }, "Business Name"),
                    React.createElement(Textbox, { id: "nameValue", placeholder: "Business Name", type: "search", value: rawNameValue, onChange: (event) => setRawNameValue(event.target.value), isSearch: true, onSearch: () => {
                            onNameChange(rawNameValue);
                        } }))),
                mode === 'location' && (React.createElement(S.FieldWrapper, null,
                    React.createElement(S.FieldLabel, { htmlFor: "locationValue" }, "Location"),
                    React.createElement(Textbox, { id: "locationValue", placeholder: "Location", type: "search", value: rawLocationValue, onChange: (event) => setRawLocationValue(event.target.value), isSearch: true, onSearch: () => {
                            onLocationChange(rawLocationValue);
                        } })))))));
};
export default HTAMemberSearch;
